/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:59]
Permissions to update outside the main branch: [false]
*/

import { Button, ValidatedInput } from '@finbeat/react-toolkit';
import { faPlus, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import { LeadgenInfo, LeadgenUtmParamInfo } from 'models/api/leadgen';
import { useFormContext } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

export const emptyItem: LeadgenUtmParamInfo = {
    id: null,
    paramCode: '',
    paramName: '',
    sd: null,
    ed: null,
    isDeleted: false,
};

type LeadgenModalUtmParamsProps = {
    disabled: boolean;
};

const LeadgenModalUtmParams = ({ disabled }: LeadgenModalUtmParamsProps) => {
    const { setValue, getValues, watch } = useFormContext<LeadgenInfo>();

    const addRefferallink = () => {
        setValue('utmParams', [...getValues().utmParams, emptyItem]);
    };

    const deleteRefferallink = (id: number | null, ids: number) => {
        setValue(
            'utmParams',
            getValues().utmParams.map((x, i) => (i === ids ? { ...x, isDeleted: true } : x))
        );
    };

    const utmParams = watch('utmParams');

    return (
        <>
            {utmParams && utmParams.length ? (
                utmParams.map(
                    (item, ids) =>
                        !item.isDeleted && (
                            <Card className="mb-3" key={ids}>
                                <CardHeader className="leadgen-modal__card-header">
                                    <>
                                        {item.id ? `#${item.id}` : t('BackOfficeNew')}
                                        <Button
                                            color="danger"
                                            onClick={() => deleteRefferallink(item.id, ids)}
                                            disabled={disabled}
                                        >
                                            <FontAwesomeIcon icon={faTrashCan} />
                                        </Button>
                                    </>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <ValidatedInput
                                                name={`utmParams[${ids}].paramCode`}
                                                label={t('BackOfficeParamCode')}
                                                disabled={disabled}
                                            />
                                        </Col>
                                        <Col>
                                            <ValidatedInput
                                                name={`utmParams[${ids}].paramName`}
                                                label={t('BackOfficeParamName')}
                                                disabled={disabled}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        )
                )
            ) : (
                <></>
            )}
            <Button color="secondary" onClick={addRefferallink} disabled={disabled}>
                <FontAwesomeIcon icon={faPlus} /> <Trans i18nKey="BackOfficeAdd" />
            </Button>
        </>
    );
};

export default LeadgenModalUtmParams;
